<!-- Page Content -->
<div id="page-content">
  <div class="container" *ngFor="let faculty of facultyData let i=index">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-12">

        <div id="page-main">
          <section id="contact">
            <header><h3>Contact</h3></header>
            <div class="row">
              <div class="col-md-4">
                <address>
                  <h3>{{faculty.faculty_name}}</h3>
                  <br>
                  <span>{{faculty.add_line1}}, {{faculty.add_line2}}</span>
                  <br>
                  <span>{{faculty.city}}</span><br>
                  <span>{{faculty.country}}, {{faculty.postal_code}}</span>
                  <br><br>
                  <i class="fa fa-phone"></i>&nbsp; {{faculty.phone}}
                  <br>
                  Ext: &nbsp; {{faculty.extensions}}
                  <br><br>
                  <i class="fa fa-envelope"></i>&nbsp; <a href="#">{{faculty.email}}</a>
                </address>
<!--                <div class="icons">-->
<!--                  <a href=""><i class="fa fa-twitter"></i></a>-->
<!--                  <a href=""><i class="fa fa-facebook"></i></a>-->
<!--                  <a href=""><i class="fa fa-pinterest"></i></a>-->
<!--                  <a href=""><i class="fa fa-youtube-play"></i></a>-->
<!--                </div>&lt;!&ndash; /.icons &ndash;&gt;-->
                <hr>
                <p>
                  For any further information.
                </p>
              </div>
              <div class="col-md-8">
                <div class="map-wrapper">
                <iframe width="100%" height="350" id="gmap_canvas" src="https://maps.google.com/maps?q=university%20of%20ruhuna&t=&z=16&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                </div>
              </div>


            </div>
          </section>
          <section id="contact-form" class="clearfix">
            <header><h2>Send Us a Message</h2></header>
            <form [formGroup]="contactForm">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label">Your Name <span class="invalid-input">*</span></label>
                    <input type="text"
                           class="form-control"
                           formControlName="your_name">
                    <div *ngFor="let validation of validationMessages.your_name">
                      <p class="invalid-input" *ngIf="contactForm.get('your_name').hasError(validation.type) && (contactForm.get('your_name').dirty || contactForm.get('your_name').touched)">
                        {{validation.message | translate}}
                      </p>
                    </div>
                  </div>
                </div><!-- /.col-md-4 -->
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label">Email <span class="invalid-input">*</span></label>
                    <input type="text"
                           class="form-control"
                           formControlName="email">
                    <div *ngFor="let validation of validationMessages.email">
                      <p class="invalid-input" *ngIf="contactForm.get('email').hasError(validation.type) && (contactForm.get('email').dirty || contactForm.get('email').touched)">
                        {{validation.message | translate}}
                      </p>
                    </div>
                  </div>
                </div><!-- /.col-md-4 -->
              </div><!-- /.row -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="control-label">Message <span class="invalid-input">*</span></label>
                    <textarea class="form-control"
                              formControlName="message"
                              rows="3"></textarea>
                    <div *ngFor="let validation of validationMessages.message">
                      <p class="invalid-input" *ngIf="contactForm.get('message').hasError(validation.type) && (contactForm.get('message').dirty || contactForm.get('message').touched)">
                        {{validation.message | translate}}
                      </p>
                    </div>
                  </div>
                </div>
              </div><!-- /.row -->

              <div class="row div-pro">
                  <div *ngIf="isLoading" class="loader">
                  </div>
              </div>

              <div class="pull-right">

                <ng-container>
                  <button type="button" class="btn btn-warning"
                          [disabled]="contactForm.invalid || contactForm.pristine"
                          (click)="emailInformation()">
                    <i data-feather="plus" appFeatherIcon></i>
                    Send a Message
                  </button>
                </ng-container>


              </div><!-- /.form-actions -->
              <div id="form-status"></div>
            </form><!-- /.footer-form -->
          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
